import React from 'react';
import PropTypes from 'prop-types';

/**
 * Display content of a story introduction
 * @param {*} props 
 * @returns 
 */
function StoryIntro(props){

    const {introduction, imageURL} = props;
    const [startParagraph, endParagraph] = parseIntroText(introduction)
    
    // Show title and subtitle if there is no start or end paragraph
    const showTitleSubtitle = startParagraph === 'title'; // If textIntroductions key is "title", then we show the title and subtitle
    const formattedTitle = props.title ? props.title.trim() : undefined;
    const formattedSubtitle = props.subtitle ? props.subtitle.trim() : undefined;

    return (
        <div className="storyIntro">
            {!showTitleSubtitle && startParagraph && <p className='start-paragraph'>{startParagraph}</p>}
            {imageURL && <img className='intro-image' src={imageURL} alt=""/>}
            {!showTitleSubtitle && endParagraph && <p className='end-paragraph'>{endParagraph}</p>}
            {showTitleSubtitle && formattedTitle && formattedTitle !== "" && <p className='story-intro-title-text'>{formattedTitle}</p>}
            {showTitleSubtitle && formattedSubtitle && formattedSubtitle !== "" && <p className='story-intro-subtitle-text'>{formattedSubtitle}</p>}
        </div>
    );
}

StoryIntro.propTypes = {
    introduction: PropTypes.string.isRequired,
    imageURL: PropTypes.string,
    title: PropTypes.string,
    author: PropTypes.string,
}

/**
 * parse the input text, returns 2 sections of text before and after the <img/> tag for rendering
 * @param {String} text introduction text
 * @returns an array with start text and end text
 */
 function parseIntroText(text){

    if(!text) return []

    const imageTag = "<img/>"
    const imagePostion = text.indexOf(imageTag)
    
    if(imagePostion < 0) return [text, null]

    const startParagraph = text.substring(0, imagePostion)
    const endParagraph = text.substring(imagePostion+imageTag.length)
    return [startParagraph, endParagraph]
}


export default StoryIntro